import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NotificationsAccountTab = "groups" | "me";

interface NotificationsV2AccountState {
  /** Active tab on `/account/notifications` — drives SideNav filter visibility. */
  activeTab: NotificationsAccountTab;
}

const initialState: NotificationsV2AccountState = {
  activeTab: "groups",
};

const notificationsV2AccountSlice = createSlice({
  name: "notificationsV2Account",
  initialState,
  reducers: {
    setNotificationsAccountTab: (
      state,
      action: PayloadAction<NotificationsAccountTab>
    ) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setNotificationsAccountTab } = notificationsV2AccountSlice.actions;

export default notificationsV2AccountSlice.reducer;
